import { createFileRoute } from '@tanstack/react-router';
import WaitlistPage from '@/pages/waitlist/WaitlistPage';

export type WaitlistView = 'open' | 'closed' | 'all';

export interface WaitlistSearch {
  /** Selected entry, or 'new' for the add sheet. */
  id?: string;
  view?: WaitlistView;
}

const VIEWS: readonly WaitlistView[] = ['open', 'closed', 'all'];

export const Route = createFileRoute('/_authenticated/waitlist')({
  validateSearch: (raw: Record<string, unknown>): WaitlistSearch => ({
    id: typeof raw.id === 'string' ? raw.id : undefined,
    view: VIEWS.includes(raw.view as WaitlistView) ? (raw.view as WaitlistView) : undefined,
  }),
  component: WaitlistPage,
});
